import { computed, ref, getCurrentInstance } from "vue-demi";
import { defineStore } from "pinia";

export const useAppStore = defineStore("app", () => {
  const vm = getCurrentInstance().proxy;
  const userData = ref({});
  const userRole = ref("");
  const selectedCustomer = ref(null);
  const loadingCustomer = ref(true);
  // Sadece bellekte tutulur, localStorage'a yazılmaz — aksi halde farklı bir
  // hesapla login olunduğunda önceki kullanıcının mutabakat verisi kısa süreliğine
  // (API'den taze veri gelene kadar) yanlışlıkla gösterilebilir. Her sayfa
  // yüklemesinde/route değişiminde App.vue API'den taze veri çeker.
  const pendingMutabakat = ref([]);

  const isCustomer = computed(() => {
    const result = [];

    // İstenilen şart
    const condition = (item) => item === true;

    // ŞART 1 => Kullanıcı tipine göre (userRole okunur: $ability reaktif değil,
    // girişte rol değişince computed yeniden hesaplansın)
    userRole.value;
    vm.$ability.can("view", "asl-customer-select") ? result.push(true) : result.push(false);

    // ŞART 2 => Müşteri seçimi yapıldı mı
    selectedCustomer.value === "" || selectedCustomer.value === null || typeof selectedCustomer.value === "undefined"
      ? result.push(true)
      : result.push(false);

    return result.every(condition);
  });

  const isMngr = computed(() => {
    const result = [];

    // İstenilen şart
    const condition = (item) => item === true;

    // ŞART 1 => Kullanıcı tipine göre (userRole okunur: $ability reaktif değil,
    // girişte rol değişince computed yeniden hesaplansın)
    userRole.value;
    vm.$ability.can("view", "asl-customer-select") ? result.push(true) : result.push(false);

    return result.every(condition);
  });

  // Onaylama süresi (max_approve_date) geçmiş mutabakat varsa true — sipariş
  // ekranlarında ürün listesi/sepete ekleme yerine uyarı gösterilir
  const hasOverdueMutabakat = computed(() =>
    (pendingMutabakat.value || []).some((item) => item.must_approve)
  );

  return {
    userData,
    userRole,
    selectedCustomer,
    loadingCustomer,
    isCustomer,
    isMngr,
    pendingMutabakat,
    hasOverdueMutabakat,
  };
});
